import { message } from 'antd';
import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useLocation } from 'react-router-dom';
import styles from './SearchSoft.module.less';

import CardIndex from '../../card/CardIndex/CardIndex';
import ALineCard from '../../components/ALineCard/NSALineCard';
import CommReco from '../../components/CommReco/CommReco';
import LineCard from '../../components/LineCard/NSLineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import Toast from '../../components/Toast/Toast';
import Dialog from '../../components/Dialog/Dialog';
import ZtSearchCard from '../../components/ZtSearchCard/ZtSearchCard';
import WebLineCard from '../../components/LineCard/WebLineCard';

import { getQueryString } from '../../utils/utils';

import { getSearchApp } from '../../actions/searchResult';
import { logging, logPostInfo } from '../../actions/log';
import { updateSearchParam } from '../../actions/searchResult';
import _LogInView from '../../components/_LogInView/_LogInView';
import { getSoftType } from '../../utils/utils';
import UserSurveyEPage from '../../components/UserSurvey/UserSurveyEPage';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectSearchInfo = createSelector(
  state => state.search,
  search => search,
);
const selectSearchKw = createSelector(
  state => state.layout,
  layout => layout.searchKw,
);
const selectSearchResultObj = createSelector(
  state => state.searchResult,
  searchResult => searchResult,
);

export default memo(({ scrollNode, logInfo }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const { searchParam, searchSoft, searchCount } = useSelector(selectSearchResultObj);
  const { searchRecommend, searchResult, feedbackVisible } = useSelector(selectSearchInfo);

  const [activeTab, setActiveTab] = useState('soft');

  const keyword = getQueryString('keyword');
  const firstId = getQueryString('firstId');
  const androidType = getQueryString('androidType');

  // 浏览时长打桩
  const leaveTimeLog = useCallback(
    initTime => {
      const keyword = getQueryString('keyword');
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Search`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word || keyword,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            keyword,
            searchParam,
          },
          param3: searchSoft.bizInfo,
        }),
      );
    },
    [logInfoData, searchParam, searchSoft],
  );
  // 统计页面浏览时长
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      leaveTimeLog(initTime);
    };
  }, []);

  /**
   * 当数据为activeTab数据，tab为activeTab，且请求的是第一页的数据
   * 上报请求完成的桩，当做一次搜索结果成功的上报
   */
  useEffect(() => {
    if (
      searchParam?.searchWord === searchSoft?.searchParam?.searchWord &&
      searchParam?.activeTab === 'soft' &&
      searchParam?.sortTypeSel === searchSoft?.searchParam?.sortTypeSel &&
      searchParam?.softCategorySel === searchSoft?.searchParam?.softCategorySel &&
      searchSoft?.loading === 200
    ) {
      // 请求数据成功
      if (searchSoft?.dataList?.length > 0 && searchSoft?.dataList?.length <= 48) {
        dispatch(
          logging({
            category: 'R',
            action: 'SearchResult',
            label: '',
            param2: {
              source: 'Search',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              has_content: searchSoft?.dataList?.length > 0 ? 1 : 0,
              search_type: logInfoData.search_type,
              search_word: logInfoData.search_word || keyword,
              keyword,
            },
            param3: searchSoft?.bizInfo,
          }),
        );
      }
      // 请求数据为空
      if (searchSoft?.dataList?.length === 0) {
        dispatch(
          logging({
            category: 'R',
            action: 'SearchResult_NoData',
            label: '',
            param2: {
              source: 'Search',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              has_content: searchSoft?.dataList?.length > 0 ? 1 : 0,
              search_type: logInfoData.search_type,
              search_word: logInfoData.search_word || keyword,
              keyword,
            },
            param3: searchSoft?.bizInfo,
          }),
        );
      }
    }
  }, [searchSoft, searchParam]);

  useEffect(() => {
    // 当searchParam参数和  返回的数据中pageParam参数不一致的时候，就重新请求页面数据
    if (
      !(
        searchParam?.searchWord === searchSoft?.searchParam?.searchWord &&
        searchParam?.activeTab === searchSoft?.searchParam?.activeTab &&
        searchParam?.sortTypeSel === searchSoft?.searchParam?.sortTypeSel &&
        searchParam?.softCategorySel === searchSoft?.searchParam?.softCategorySel
      )
    ) {
      let params = {
        refresh: true,
        searchWord: getQueryString('keyword'),
        firstId: firstId,
        androidType: androidType,
        sortTypeSel: searchParam?.sortTypeSel || '0',
        softCategorySel: searchParam?.softCategorySel || '0',
        algoBizInfo: searchSoft?.algoBizInfo || '',
        serviceBizInfo: searchSoft?.serviceBizInfo || '',
      };
      // 如果切换搜索词
      if (searchParam?.searchWord !== searchSoft?.searchParam?.searchWord) {
        params.algoBizInfo = '';
      }

      if (getQueryString('bizinfo')) {
        params.serviceBizInfo = getQueryString('bizinfo');
      }
      // 传入相关数据（重新）请求数据
      dispatch(getSearchApp(params));
    }
  }, [searchSoft, searchParam]);

  const handleSearchOut = () => {
    window.open(`https://www.baidu.com/s?wd=${keyword}`);
    dispatch(
      logging({
        category: 'C',
        action: 'Search_To_Browser',
        label: '',
        param2: {
          source: 'Search',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word || keyword,
          keyword,
          searchParam,
        },
      }),
    );
  };

  if (
    !searchSoft ||
    !searchSoft?.loading ||
    searchSoft?.loading !== 200 ||
    searchSoft?.searchParam?.searchWord !== getQueryString('keyword')
  ) {
    return (
      <div className={styles.s_loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.s_soft}>
      {searchSoft?.dataList?.length > 0 && (
        <div className="list">
          {searchSoft?.hint && <div className="list_line_text">{searchSoft?.hint}</div>}
          {searchSoft?.dataList?.map((soft, i) => {
            if (soft.itemType === 1 || soft.itemType === 2 || soft.itemType === 8) {
              if (soft.androidType === '1') {
                return (
                  <React.Fragment key={i}>
                    <_LogInView
                      logInfo={{
                        ...logInfo,
                        logAction: 'Search_App_Show',
                        softid: soft?.packageName,
                        softType: getSoftType(soft),
                        location: i + 1,
                        lenovo_bizinfo: { ...JSON.parse(searchSoft?.bizInfo) },
                        softName: soft?.softName,
                        source: 'Search',
                        search_type: logInfoData.search_type,
                        search_word: logInfoData.search_word || keyword,
                      }}
                      cardData={soft}
                    >
                      <ALineCard
                        logInfo={{
                          source: 'Search',
                          isSearch: true,
                          isFasterProduct: true,
                          search_type: logInfoData.search_type,
                          search_word: logInfoData.search_word || keyword,
                        }}
                        soft={soft}
                        key={i}
                      />
                    </_LogInView>

                    {searchRecommend[soft.packageName] &&
                      searchRecommend[soft.packageName].apps &&
                      searchRecommend[soft.packageName].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.packageName]}
                          logInfo={{
                            source: `Search|| ||DReco||${soft.packageName}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                            search_type: logInfoData.search_type,
                            search_word: logInfoData.search_word || keyword,
                          }}
                        />
                      )}
                  </React.Fragment>
                );
              } else if (soft.androidType === '3') {
                return (
                  <React.Fragment key={i}>
                    <_LogInView
                      logInfo={{
                        ...logInfo,
                        logAction: 'Search_App_Show',
                        softid: soft?.androidType === '1' ? soft?.packageName : soft?.softID,
                        softType: getSoftType(soft),
                        location: i + 1,
                        lenovo_bizinfo: { ...JSON.parse(searchSoft?.bizInfo) },
                        softName: soft?.softName,
                        source: 'Search',
                        search_type: logInfoData.search_type,
                        search_word: logInfoData.search_word || keyword,
                      }}
                      cardData={soft}
                    >
                      <LineCard
                        logInfo={{
                          source: 'Search',
                          isSearch: true,
                          search_type: logInfoData.search_type,
                          search_word: logInfoData.search_word || keyword,
                        }}
                        soft={soft}
                        info={{ isCompetitive: true, isFasterProduct: true }}
                      />
                    </_LogInView>
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment key={i}>
                    <_LogInView
                      logInfo={{
                        ...logInfo,
                        logAction: 'Search_App_Show',
                        softid: soft?.softID,
                        softType: getSoftType(soft),
                        location: i + 1,
                        lenovo_bizinfo: { ...JSON.parse(searchSoft?.bizInfo) },
                        softName: soft?.softName,
                        source: 'Search',
                        search_type: logInfoData.search_type,
                        search_word: logInfoData.search_word || keyword,
                      }}
                      cardData={soft}
                    >
                      <LineCard
                        logInfo={{
                          source: 'Search',
                          isSearch: true,
                          search_type: logInfoData.search_type,
                          search_word: logInfoData.search_word || keyword,
                        }}
                        soft={soft}
                        info={{ isCompetitive: true, isFasterProduct: true }}
                      />
                    </_LogInView>

                    {searchRecommend[soft.softID] &&
                      searchRecommend[soft.softID].apps &&
                      searchRecommend[soft.softID].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.softID]}
                          logInfo={{
                            source: `Search|| ||DReco||${soft.softID}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                            search_type: logInfoData.search_type,
                            search_word: keyword,
                            isSearch: true,
                          }}
                        />
                      )}
                  </React.Fragment>
                );
              }
            }
            {
              /**
               * temType
               * 1-PC应用,  2-android应用,  3-商店搜索结果banner,  4-浏览器搜索跳转专题和壁纸页面,
               * 5-商店联想词广告,  6-商店专题,  7-纯网页版应用,  8-网页版购买软件
               */
            }
            if (soft.itemType === 3) {
              return <CardIndex data={soft} logInfo={{ tag: 'Search' }} />;
            }
            // 专题样式
            if (soft.itemType === 6) {
              return <ZtSearchCard data={soft} key={i} logInfo={{ source: 'Search' }} />;
            }
            // 网页版软件
            if (soft.itemType === 7) {
              return (
                <_LogInView
                  key={i}
                  logInfo={{
                    ...logInfo,
                    logAction: 'Search_App_Show',
                    softid: soft.androidType === '1' ? soft?.packageName : soft?.softID,
                    softType: getSoftType(soft),
                    location: i + 1,
                    lenovo_bizinfo: { ...JSON.parse(searchSoft?.bizInfo) },
                    softName: soft?.softName,
                    source: 'Search',
                    search_type: logInfoData.search_type,
                    search_word: logInfoData.search_word || keyword,
                  }}
                  cardData={soft}
                >
                  <WebLineCard soft={soft} logInfo={{ source: 'Search' }} />
                </_LogInView>
              );
            }
            return '';
          })}
        </div>
      )}
      {searchSoft?.dataList?.length > 0 &&
        searchSoft?.dataList?.length >= searchCount?.appsCount && (
          <div className={styles.search_out} onClick={handleSearchOut}>
            没找到满意结果？试试{' '}
            <span className={styles.search_out_text}>百度搜索 &quot;{keyword}&quot;&nbsp;&gt;</span>
          </div>
        )}

      {searchSoft?.dataList?.length === 0 && (
        <div className={styles.Nosearchresult}>
          <div className="NosearchresultBox">
            <div className="noresultImg" />
            <div className="mainTextWrap">
              <div className="mainText" onClick={handleSearchOut}>
                没找到匹配结果。试试&nbsp;
                <span className={styles.search_out_text}>
                  百度搜索 &quot;{keyword}&quot;&nbsp;&gt;
                </span>
                <br />{' '}
              </div>
            </div>
          </div>
        </div>
      )}
      {((searchSoft?.dataList?.length > 0 &&
        searchSoft?.dataList?.length >= searchCount?.appsCount) ||
        !searchSoft?.dataList?.length ||
        searchSoft?.dataList?.length === 0) &&
        searchSoft?.searchParam?.searchWord == keyword && <CommReco logInfo={{ tag: 'Search' }} />}
      <UserSurveyEPage />
    </div>
  );
});
